// Handle dropdown menus for touch devices
document.addEventListener('DOMContentLoaded', function() {
    // Get all dropdown buttons
    const dropdownButtons = document.querySelectorAll('.group > button');
    
    dropdownButtons.forEach(button => {
        const parentLi = button.closest('li');
        const dropdown = parentLi.querySelector('div');
        
        // Add click event for touch devices
        button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            // Close all other dropdowns
            document.querySelectorAll('.group > div').forEach(otherDropdown => {
                if (otherDropdown !== dropdown) {
                    otherDropdown.classList.add('opacity-0', 'invisible');
                    otherDropdown.classList.remove('opacity-100', 'visible');
                }
            });
            
            // Toggle current dropdown
            if (dropdown.classList.contains('opacity-0')) {
                dropdown.classList.remove('opacity-0', 'invisible');
                dropdown.classList.add('opacity-100', 'visible');
            } else {
                dropdown.classList.add('opacity-0', 'invisible');
                dropdown.classList.remove('opacity-100', 'visible');
            }
        });
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
        if (!e.target.closest('.group')) {
            document.querySelectorAll('.group > div').forEach(dropdown => {
                dropdown.classList.add('opacity-0', 'invisible');
                dropdown.classList.remove('opacity-100', 'visible');
            });
        }
    });
    
    // Handle touch events for better mobile experience
    let touchStartY = 0;
    
    document.addEventListener('touchstart', function(e) {
        touchStartY = e.touches[0].clientY;
    }, { passive: true });
    
    document.addEventListener('touchmove', function(e) {
        const touchEndY = e.touches[0].clientY;
        const deltaY = Math.abs(touchEndY - touchStartY);
        
        // If user is scrolling, close dropdowns
        if (deltaY > 10) {
            document.querySelectorAll('.group > div').forEach(dropdown => {
                dropdown.classList.add('opacity-0', 'invisible');
                dropdown.classList.remove('opacity-100', 'visible');
            });
        }
    }, { passive: true });
});